// Google Ads Enhanced Conversions for Leads
// Docs: https://support.google.com/google-ads/answer/13258081
//
// The conversion label is configured via env var so it can be set per environment
// without touching code. If REACT_APP_GADS_CONVERSION_LABEL is not set, only the
// user_data payload is pushed and NO conversion event is fired (safe default).

const GADS_ID = "AW-18318674017";
const CONVERSION_LABEL = process.env.REACT_APP_GADS_CONVERSION_LABEL || "";

/**
 * Normalize phone to E.164 (Google's required format for Enhanced Conversions).
 * Defaults to Spain (+34) if no country code detected.
 */
export function normalizePhoneE164(raw, defaultCountryCode = "+34") {
  if (!raw) return "";
  const digits = String(raw).replace(/[^\d+]/g, "");
  if (digits.startsWith("+")) return digits;
  // Bare number without country code → prepend default
  return `${defaultCountryCode}${digits.replace(/^0+/, "")}`;
}

/**
 * Normalize an email: trim, lowercase.
 */
export function normalizeEmail(raw) {
  if (!raw) return "";
  return String(raw).trim().toLowerCase();
}

/**
 * Split a full name into { first_name, last_name } (best-effort).
 */
function splitName(fullName = "") {
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 0) return {};
  if (parts.length === 1) return { first_name: parts[0].toLowerCase() };
  return {
    first_name: parts[0].toLowerCase(),
    last_name: parts.slice(1).join(" ").toLowerCase(),
  };
}

/**
 * Fires an Enhanced Conversion for Leads with plaintext user data
 * (Google will hash it server-side when "Automatic collection" is enabled).
 */
export function fireEnhancedConversion({ email, phone, name, value, currency = "EUR" } = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  const emailNorm = normalizeEmail(email);
  const phoneNorm = normalizePhoneE164(phone);
  const { first_name, last_name } = splitName(name);

  const userData = {};
  if (emailNorm) userData.email = emailNorm;
  if (phoneNorm) userData.phone_number = phoneNorm;
  if (first_name || last_name) {
    userData.address = {
      ...(first_name ? { first_name } : {}),
      ...(last_name ? { last_name } : {}),
      country: "ES",
    };
  }

  if (Object.keys(userData).length > 0) {
    window.gtag("set", "user_data", userData);
  }

  if (CONVERSION_LABEL) {
    const eventPayload = { send_to: `${GADS_ID}/${CONVERSION_LABEL}` };
    if (typeof value === "number") {
      eventPayload.value = value;
      eventPayload.currency = currency;
    }
    window.gtag("event", "conversion", eventPayload);
  }
}
